import { Controller } from "remult";

@Controller("opportunity-category-methods")
export class OpportunityCategoryMethods {}








